import { API_BASE_URL as BASE } from './apiConfig';
import { createAuthedAxios } from '@/lib/authedAxios';

const client = createAuthedAxios({ baseURL: `${BASE}/api/naver-smartstore` });

// B/E 표준 응답({success,message,data})을 언랩 - cafe24Api.ts와 동일 패턴
client.interceptors.response.use((res) => {
  if (res.data && typeof res.data === 'object' && 'success' in res.data && 'data' in res.data) {
    const wrapped = res.data as { success: boolean; message?: string | null; data: unknown };
    res.data = wrapped.data;
  }
  return res;
});

export type NaverSmartstoreStatus = 'ACTIVE' | 'AUTH_FAILED' | 'DISCONNECTED';

export interface NaverSmartstoreConnectionStatus {
  connected: boolean;
  status: NaverSmartstoreStatus | null;
  channelId: string | null;
  sellerName: string | null;
  connectedAt: string | null;
}

export async function getNaverSmartstoreStatus(): Promise<NaverSmartstoreConnectionStatus> {
  const res = await client.get<NaverSmartstoreConnectionStatus>('/status');
  return res.data;
}

export async function connectNaverSmartstore(
  applicationId: string,
  applicationSecret: string,
): Promise<NaverSmartstoreConnectionStatus> {
  const res = await client.post<NaverSmartstoreConnectionStatus>('/connect', {
    applicationId,
    applicationSecret,
  });
  return res.data;
}

export async function disconnectNaverSmartstore(): Promise<NaverSmartstoreConnectionStatus> {
  const res = await client.delete<NaverSmartstoreConnectionStatus>('/disconnect');
  return res.data;
}
